export default __webpack_public_path__ + "static/media/finanacialBasics.94895704.jpg";